function resolveImportMapUrls(importMap, origin) {
  const base = origin ?? globalThis.location?.origin ?? "";
  const resolved = {};
  for (const [key, value] of Object.entries(importMap)) {
    resolved[key] = value.startsWith("/") ? base + value : value;
  }
  return resolved;
}
export {
  resolveImportMapUrls
};
//# sourceMappingURL=resolve-import-map-urls.js.map
